var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',[_c('b-tabs',{attrs:{"vertical":"","nav-wrapper-class":"nav-vertical"}},[_c('b-tab',{attrs:{"active":"","title":"Change Password"}},[_c('b-card',[_c('ChangePassword')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }